export function buildUrlWithFacility(facility: string, url: string): string {
  return `/${facility}${url}`;
}
